module.exports = __webpack_public_path__ + "static/media/211IT066.1b6a4eec.jpg";